import script from "./Save_Category.vue?vue&type=script&setup=true&lang=js"
export * from "./Save_Category.vue?vue&type=script&setup=true&lang=js"

import "./Save_Category.vue?vue&type=style&index=0&id=25731f83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25731f83"]])

export default __exports__